import type { FeatureManifest } from '../registry.js';
import { BallotIcon } from './icon.js';
import { announcedThisMonth, firstSessionOver, votedThisMonth } from './memo.js';

/**
 * SO-10 city vote (P2): once a month the player picks the next city from 3 candidates (one
 * vote per account), sees the live and final results by region and shares the public
 * results page. The map announces each new month's vote once, after the first session.
 */
export default {
  id: 'vote',
  flag: 'cityVote',
  online: true,
  provides: ['cityVote', 'cityVoteResults', 'cityVoteNews'],
  entry: { order: 70, icon: BallotIcon, label: 'feature.vote.rail', testId: 'rail-vote', open: 'cityVote', badge: (a) => firstSessionOver(a) && !votedThisMonth(a) },
  // an announcement, after deliveries, results, offers and first-session prompts
  mapOrder: 45,
  mapDue: (a) => a.services.sync.status !== 'offline' && !a.session.checked.has('vote') && firstSessionOver(a) && !announcedThisMonth(a) && !votedThisMonth(a),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
